import { render, staticRenderFns } from "./ReportRecipients.vue?vue&type=template&id=4c7152d8&"
import script from "./ReportRecipients.vue?vue&type=script&lang=ts&"
export * from "./ReportRecipients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports